import { createApp } from 'vue';
import App from './App.vue';
import { InitCommonLibs, InitGlobalSideModal } from 'scriptsShared/Inits.js';
import { createI18n } from 'vue-i18n';
import cs_cz from '../../../../Scripts/cs-CZ.json';
import sk_sk from '../../../../Scripts/sk-SK.json';

const i18n = createI18n({
    locale: initialData.locale,
    messages: {
        'cs-CZ': cs_cz,
        'sk-SK': sk_sk
    }
});

import withUUID from 'vue-uuid';
const app = withUUID(createApp(App, {
    initialData: initialData
}));

InitCommonLibs(app, initialData.locale);
InitGlobalSideModal(app, initialData);

app.use(i18n);

app.mount('#app');
